import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const recommendSalesSettings = createServerFn({ method: "POST" })
  .inputValidator(
    z.object({
      conditions: z.string().trim().min(5).max(1500),
      eventDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
      eventTime: z.string().regex(/^\d{2}:\d{2}$/),
      timezone: z.string().max(64),
      isVirtual: z.boolean(),
      ticketTypes: z.array(z.object({ name: z.string().max(100), price: z.number().min(0), total: z.number().int().min(0) })).max(10),
    }),
  )
  .handler(async ({ data }) => {
    const { getAuthenticatedUserId } = await import("@/lib/auth.server");
    await getAuthenticatedUserId(); // solo usuarios con sesión
    const { recommendSalesConfig } = await import("./sales-advisor.server");
    return recommendSalesConfig({
      ...data,
      ticketTotal: data.ticketTypes.reduce((s, t) => s + t.total, 0),
      nowIso: new Date().toISOString(),
    });
  });
